function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { STORAGE_KEYS as s } from "./storage-manager.js";
import u from "./subscription-manager.js";
import Qt from "../models/server-config.js";
import c from "../common/event-logger.js";
import { EventTypes as d } from "../../shared-lib/index.js";

var Mt = /*#__PURE__*/function () {
  function Mt(t) {
    _classCallCheck(this, Mt);

    this.C = t, this.C = t, this.sl = new u(), this.rl = new u(), this.ul = new u(), this.al = new u(), this.hl = null, this.ol = null;
  }

  _createClass(Mt, [{
    key: "cl",
    value: function cl() {
      if (null == this.ol) {
        var t = this.C.ft(s.gt.ml);
        this.ol = null != t ? Qt.Rn(t) : new Qt();
      }

      return this.ol;
    }
  }, {
    key: "Et",
    value: function Et() {
      return this.cl().dl;
    }
  }, {
    key: "gl",
    value: function gl(t) {
      var _this = this;

      var i, e;

      if (null != t && null != t.config) {
        var n = t.config;

        if (n.time > this.cl().dl) {
          var _t = function _t(t) {
            return null == t ? _this.cl().bl : t;
          },
              r = new Qt(n.time, n.events_blacklist, n.attributes_blacklist, n.purchases_blacklist, n.messaging_session_timeout, n.vapid_public_key, n.content_cards, n.feature_flags, _t(n.global_request_rate_limit), n.banners);

          var l = !1;
          null != r.fl && this.In() !== r.fl && (l = !0);

          var _u = !1;

          null != r.vl.enabled && this.yi() !== r.vl.enabled && (_u = !0);
          var a = !1;
          null != r.De.enabled && this.ke() !== r.De.enabled && (a = !0);
          var h = !1;
          null != (null === (i = r.banners) || void 0 === i ? void 0 : i.enabled) && this.zt() !== (null === (e = r.banners) || void 0 === e ? void 0 : e.enabled) && (h = !0), this.ol = r, this.C.Bt(s.gt.ml, r.bt()), l && this.sl.X(), _u && this.rl.X(), a && this.ul.X(), h && this.al.X();
        }
      }
    }
  }, {
    key: "Vn",
    value: function Vn(t) {
      var i = this.sl.Dt(t);
      return this.hl && this.sl.removeSubscription(this.hl), this.hl = i, i;
    }
  }, {
    key: "gi",
    value: function gi(t) {
      return this.rl.Dt(t);
    }
  }, {
    key: "Ke",
    value: function Ke(t) {
      return this.ul.Dt(t);
    }
  }, {
    key: "A",
    value: function A(t) {
      return this.al.Dt(t);
    }
  }, {
    key: "je",
    value: function je(t) {
      return -1 !== this.cl().Rl.indexOf(t);
    }
  }, {
    key: "hu",
    value: function hu(t) {
      return -1 !== this.cl().Cl.indexOf(t);
    }
  }, {
    key: "Dr",
    value: function Dr(t) {
      return -1 !== this.cl().El.indexOf(t);
    }
  }, {
    key: "wl",
    value: function wl() {
      return this.cl().yl;
    }
  }, {
    key: "In",
    value: function In() {
      return this.cl().fl;
    }
  }, {
    key: "yi",
    value: function yi() {
      return this.cl().vl.enabled || !1;
    }
  }, {
    key: "Ll",
    value: function Ll() {
      var t = this.cl().bl;
      return !(!t || null == t.enabled) && t.enabled;
    }
  }, {
    key: "Zu",
    value: function Zu() {
      if (!this.Ll()) return -1;
      var t = this.cl().bl;
      return null == t.capacity || t.capacity < 10 ? -1 : t.capacity;
    }
  }, {
    key: "tl",
    value: function tl() {
      if (!this.Ll()) return -1;
      var t = this.cl().bl;
      return null == t.refill_rate || t.refill_rate <= 0 ? -1 : t.refill_rate;
    }
  }, {
    key: "Bl",
    value: function Bl(t) {
      var i = this.cl().bl.endpoint_overrides;
      return null == i ? null : i[t];
    }
  }, {
    key: "el",
    value: function el(t) {
      var i = this.Bl(t);
      return null == i || isNaN(i.capacity) || i.capacity <= 0 ? -1 : i.capacity;
    }
  }, {
    key: "il",
    value: function il(t) {
      var i = this.Bl(t);
      return null == i || isNaN(i.refill_rate) || i.refill_rate <= 0 ? -1 : i.refill_rate;
    }
  }, {
    key: "ke",
    value: function ke() {
      return this.cl().De.enabled && null == this.Oe() ? (c.ut(d.qu, {
        e: "Missing feature flag refresh_rate_limit."
      }), !1) : this.cl().De.enabled || !1;
    }
  }, {
    key: "Oe",
    value: function Oe() {
      return this.cl().De.refresh_rate_limit;
    }
  }, {
    key: "zt",
    value: function zt() {
      var t;
      return (null === (t = this.cl().banners) || void 0 === t ? void 0 : t.enabled) || null;
    }
  }, {
    key: "ne",
    value: function ne() {
      var t;
      return (null === (t = this.cl().banners) || void 0 === t ? void 0 : t.max_placements) || 0;
    }
  }]);

  return Mt;
}();

export { Mt as default };